function ParseTime(time) {
  const timeArray = time.split(":");
  const hours = parseInt(timeArray[0]) || 0;
  const minutes = parseInt(timeArray[1]) || 0;
  const seconds = parseInt(timeArray[2]) || 0;

  const result = hours * 3600 + minutes * 60 + seconds;

  return result;
}

export default ParseTime;